import React, { useEffect, useState } from "react";
import { ScrollText, Loader2 } from "lucide-react";
import { api } from "../../../lib/api";
import { Drawer } from "../../../components/Drawer";
import { KINDS, fmtMs, fmtWib, monErr } from "./monUtil";

const FIELDS = { http: [["method", "Method"], ["path", "Path"], ["status", "Status"], ["ttfb_ms", "TTFB", fmtMs]], llm: [["capability", "Kapabilitas"], ["provider", "Provider"], ["model", "Model"]], db: [["command", "Command"], ["collection", "Koleksi"]], storage: [["op", "Operasi"], ["backend", "Backend"], ["path", "Key objek"]], ws: [["channel", "Kanal"], ["event", "Event"], ["status", "Kode"], ["close_reason", "Alasan tutup"], ["recipients", "Penerima"], ["failed", "Gagal kirim"], ["msg_type", "Tipe pesan"]] };

function Row({ label, children, testid }) {
  return <div className="grid grid-cols-[110px_1fr] gap-3 border-b border-line py-2 text-xs last:border-0"><dt className="font-semibold text-slate-500">{label}</dt><dd className="break-all font-mono text-slate-900" data-testid={testid}>{children ?? "—"}</dd></div>;
}

export function LogDetail({ id, onClose }) {
  const [log, setLog] = useState(null); const [err, setErr] = useState("");
  useEffect(() => {
    if (!id) return;
    setLog(null); setErr("");
    api.get(`/platform/monitoring/logs/${id}`).then((r) => setLog(r.data)).catch((e) => setErr(e?.response?.status === 404 ? "Log tidak ditemukan atau sudah melewati retensi 7 hari." : monErr(e)));
  }, [id]);
  return (
    <Drawer open={!!id} onClose={onClose} title="Detail log" subtitle={id ? `ID ${id}` : ""} icon={ScrollText} testid="mon-log-detail">
      {err && <p className="rounded-xl bg-rose-50 px-4 py-3 text-sm font-semibold text-rose-700" data-testid="mon-log-detail-error">{err}</p>}
      {!log && !err && <div className="flex justify-center py-10"><Loader2 className="animate-spin text-brand" /></div>}
      {log && (
        <>
          <div className="flex items-center gap-2">
            <span className={`rounded-full px-2.5 py-1 text-[11px] font-bold ${log.ok ? "bg-emerald-50 text-emerald-700" : "bg-rose-50 text-rose-700"}`} data-testid="mon-log-detail-ok">{log.ok ? "Berhasil" : "Gagal"}</span>
            <span className="rounded-full bg-slate-100 px-2.5 py-1 text-[11px] font-bold text-slate-600">{KINDS[log.kind]?.label || log.kind}</span>
            <span className="ml-auto font-mono text-lg font-black text-slate-900" data-testid="mon-log-detail-ms">{fmtMs(log.ms)}</span>
          </div>
          <dl>
            <Row label="Nama" testid="mon-log-detail-name">{log.name}</Row>
            <Row label="Waktu">{fmtWib(log.at)}</Row>
            <Row label="Instance">{log.instance}</Row>
            {(FIELDS[log.kind] || []).filter(([k]) => log.kind !== "ws" || log[k] != null).map(([k, l, f]) => <Row key={k} label={l}>{log[k] == null ? null : f ? f(log[k]) : String(log[k])}</Row>)}
          </dl>
          {log.error && <div><p className="text-[11px] font-bold uppercase tracking-wider text-rose-600">Error</p><pre className="mt-1 whitespace-pre-wrap break-all rounded-xl bg-rose-50 p-3 font-mono text-[11px] text-rose-800" data-testid="mon-log-detail-err">{log.error}</pre></div>}
        </>
      )}
    </Drawer>
  );
}
